import { useLocation } from "react-router-dom";

import { getPublicConfig } from "../../api/config/getPublicConfig";
import { getAPExternalClientURL } from "../../helpers/configuration";
import { internalToExternalPath } from "../../helpers/routes";
import CopyUrlField from "./CopyUrlField";

type CopyExternalUrlFieldProps = {
  text: string;
};

const CopyExternalUrlField = ({ text }: CopyExternalUrlFieldProps) => {
  const location = useLocation();
  const configMap = getPublicConfig();

  const hostUrl = configMap.isSuccess
    ? getAPExternalClientURL(configMap.data)
    : null;
  const url = hostUrl
    ? `${hostUrl}${internalToExternalPath(location.pathname)}${location.search}`
    : null;

  return url ? <CopyUrlField copyText={text} url={url} /> : <></>;
};

export default CopyExternalUrlField;
